<template>
  <div class="IndexFive Pt75 Mt20">
    <div class="box">
      <div class="PubTitle center">
        <h2>新闻动态</h2>
      </div>

      <div class="Click">
      </div>

      <div class="ClickShow">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading-state" style="text-align: center; padding: 50px;">
          <p>正在加载新闻数据...</p>
        </div>

        <!-- 内容区域 -->
        <template v-else>
          <div class="One OneShow" :class="{ Active: activeNewsTab === 0 }" v-show="activeNewsTab === 0">
            <div class="flex between wrap-flex-wrap">
              <div class="Dl" v-if="mainNews">
                <dl @click="openArticleModal(mainNews)">
                  <dt><img :src="mainNews.image" :alt="mainNews.title"/></dt>
                  <dd>
                    <h2>{{ mainNews.title }}</h2>
                    <p>{{ mainNews.summary }}</p>
                  </dd>
                </dl>
              </div>
              <div class="DlColumn">
                <dl v-for="newsItem in newsList" :key="newsItem.id" @click="openArticleModal(newsItem)">
                  <dt>
                    <h2>
                      <span>{{ newsItem.title }}</span>
                      <em v-if="newsItem.tag">{{ newsItem.tag }}</em>
                    </h2>
                    <i>{{ newsItem.date }}</i>
                  </dt>
                  <dd>
                    <p>{{ newsItem.summary }}</p>
                  </dd>
                </dl>
              </div>
            </div>
          </div>

          <div class="One TowShow" :class="{ Active: activeNewsTab === 1 }" v-show="activeNewsTab === 1">
            <div class="flex between wrap-flex-wrap">
              <dl v-for="activityItem in activityList" :key="activityItem.id" @click="openArticleModal(activityItem)">
                <dt><img :src="activityItem.image" class="w100" alt=""/></dt>
                <dd>
                  <h2>{{ activityItem.title }}</h2>
                  <p>{{ activityItem.summary }}</p>
                  <em v-if="activityItem.activityTime">活动时间：{{ activityItem.activityTime }}</em>
                </dd>
              </dl>
            </div>
          </div>
        </template>
      </div>
    </div>

    <ArticleDetailModal
        v-if="selectedArticle"
        :show="isModalVisible"
        :article="selectedArticle"
        @close="closeArticleModal"
    />
  </div>
</template>

<script>
import { getNewsArticle, getNewsCategory } from '@/api/request.js';
import ArticleDetailModal from '@/components/ArticleDetailModal.vue'; // 引入 ArticleDetailModal

export default {
  name: 'NewsSection',
  components: {
    ArticleDetailModal, // 注册组件
  },
  data() {
    return {
      activeNewsTab: 0, // 默认显示第一个选项卡 (例如 "新闻资讯")
      loading: false,
      newsCategories: [], // 新闻分类
      newsList: [], // 新闻列表
      activityList: [], // 活动列表
      mainNews: null, // 主要新闻（第一条）
      isModalVisible: false, // 控制模态框显示
      selectedArticle: null, // 选中的文章
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    setActiveNewsTab(index) {
      this.activeNewsTab = index;
    },

    openArticleModal(article) {
      this.selectedArticle = article;
      this.isModalVisible = true;
    },
    closeArticleModal() {
      this.isModalVisible = false;
      setTimeout(() => {
        this.selectedArticle = null;
      }, 300);
    },

    async fetchData() {
      this.loading = true;
      try {
        // 获取新闻分类和文章数据
        const [categoriesData, articlesData] = await Promise.all([
          getNewsCategory(),
          getNewsArticle({ pagesize: 20, page: 1 }) // 获取前20条文章
        ]);

        // 处理分类数据
        if (categoriesData && categoriesData.list) {
          this.newsCategories = categoriesData.list;
        }

        // 处理文章数据
        if (articlesData && articlesData.list) {
          const articles = this.processArticleData(articlesData.list);

          // 分离新闻和活动
          const newsArticles = articles.filter(article =>
            !this.isActivity(article) && article.category_id !== this.getActivityCategoryId()
          );
          const activityArticles = articles.filter(article =>
            this.isActivity(article) || article.category_id === this.getActivityCategoryId()
          );

          // 设置主新闻和新闻列表
          if (newsArticles.length > 0) {
            this.mainNews = newsArticles[0];
            this.newsList = newsArticles.slice(1, 5); // 取4条新闻
          }

          // 设置活动列表
          this.activityList = activityArticles.slice(0, 6); // 取6条活动
        }

      } catch (error) {
        console.error('获取新闻数据失败:', error);
        // 如果API调用失败，使用默认数据作为后备
        this.loadFallbackData();
      } finally {
        this.loading = false;
      }
    },

    // 判断是否为活动类型
    isActivity(article) {
      return article.activityTime ||
             article.activity_time ||
             article.event_time ||
             (article.title && article.title.includes('活动')) ||
             (article.title && article.title.includes('展会')) ||
             (article.title && article.title.includes('展览'));
    },

    // 获取活动分类ID（假设活动有特定的分类）
    getActivityCategoryId() {
      const activityCategory = this.newsCategories.find(cat =>
        cat.name.includes('活动') ||
        cat.name.includes('展会') ||
        cat.slug === 'activity' ||
        cat.slug === 'events'
      );
      return activityCategory ? activityCategory.id : null;
    },

    // 处理文章数据格式
    processArticleData(articles) {
      return articles.map(article => ({
        id: article.id || article.slug || `article-${article.id}`,
        title: article.title || '',
        tag: this.getCategoryName(article.category_id) || 'news',
        category: this.getCategoryName(article.category_id) || '新闻', // 添加 category 属性
        date: this.formatDate(article.created_at || article.published_at || article.updated_at),
        summary: article.summary || article.excerpt || this.extractSummary(article.content),
        image: article.cover_image_url || article.image_url || '/images/n123.jpg',
        fullContent: article.content || '',
        views: article.views_count || 0, // 添加 views 属性
        activityTime: this.formatDate(article.activity_time || article.event_time),
        category_id: article.category_id
      }));
    },

    // 根据分类ID获取分类名称
    getCategoryName(categoryId) {
      const category = this.newsCategories.find(cat => cat.id === categoryId);
      return category ? category.name : '';
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      try {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // 返回 YYYY-MM-DD 格式
      } catch (error) {
        return dateString;
      }
    },

    // 从内容中提取摘要
    extractSummary(content, maxLength = 150) {
      if (!content) return '';
      // 移除HTML标签
      const textContent = content.replace(/<[^>]*>/g, '');
      return textContent.length > maxLength
        ? textContent.substring(0, maxLength) + '...'
        : textContent;
    },

    // 后备数据（原静态数据）
    loadFallbackData() {
      this.newsList = [
        {
          id: 'air-purifier-exhibition',
          title: '空气净化与除湿设备展签约火爆｜健康家电智能化升级，两大核心突破引领市场',
          tag: 'news',
          date: '2025-05-20',
          summary: '2025国际空气净化与除湿设备展圆满收官！展会聚焦健康家电智能化转型，现场签约热度空前，咨询洽谈络绎不绝，成为行业焦点之一。多家企业展示的智能空气净化系统与高效抽湿解决方案引发采购热潮，凸显数智化技术对产业升级的关键作用。'
        },
        {
          id: 'smart-health-appliance',
          title: '抢占健康科技高地！5月15-18日W2#C300，体验空气净化+抽湿一体化智能生态',
          date: '2025-05-10',
          summary: '诚邀您莅临GreenTech健康科技展位W2#C300！在这里，您将体验：全球首创的空气净化与抽湿联动系统——基于AI环境感知技术，实现室内空气质量全流程智能管理，从PM2.5过滤、湿度调控到能耗优化，打造健康家居闭环生态。'
        },
        {
          id: 'iot-integration',
          title: '空气净化与抽湿设备IoT系统集成实践及国产化创新优势',
          date: '2025-04-25',
          summary: '通过物联网技术整合空气净化器与抽湿机的生产与运维，可实时监测设备运行状态并优化能效。例如，智能传感器可动态调节风速与湿度阈值，配合云端数据平台实现远程控制，显著提升用户体验与设备可靠性。'
        },
        {
          id: 'ai-health-solution',
          title: '立足健康家电智能化，AIoT+智能硬件一体化方案——破解高效净化与节能核心难题',
          date: '2025-04-18',
          summary: '随着消费者对室内健康需求激增，中国家电企业已攻克高效HEPA滤网与低功耗电机技术瓶颈，结合AI算法实现PM0.1级过滤与精准湿度控制。国产化方案在成本与性能上展现显著优势，助力全球市场拓展。'
        }
      ];

      // 设置活动列表
      this.activityList = [
        {
          id: 'tech-exhibition-2025',
          title: '2025国际智能家电技术展览会',
          summary: '展示最新的智能家电技术和解决方案，包括空气净化、除湿等健康家电产品。',
          image: '/images/activity1.jpg',
          activityTime: '2025-07-15'
        },
        {
          id: 'green-tech-summit',
          title: 'GreenTech绿色科技峰会',
          summary: '聚焦环保科技和可持续发展，探讨绿色家电的未来发展趋势。',
          image: '/images/activity2.jpg',
          activityTime: '2025-08-20'
        },
        {
          id: 'smart-home-expo',
          title: '智能家居博览会',
          summary: '全面展示智能家居生态系统，包括智能控制、环境监测等技术。',
          image: '/images/activity3.jpg',
          activityTime: '2025-09-10'
        }
      ];

      // 设置主新闻
      this.mainNews = {
        id: 'waykar-erp-2-0',
        title: 'WaykarERP2.0中台架构全球首发，智能工厂全链路协同方案破局印包行业系统应用怪圈',
        summary: 'Waykar集团投入千万级研发，打破印包行业"技术债"困局，摆脱软件几年一换的怪圈，将中台架构+业务逻辑深度融合，终结软件生命周期魔咒，为印包行业普及数智化升级开路。',
        image: '/images/n123.jpg'
      };
    }
  },
  watch: {
    isModalVisible(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
/* 您可以将 IndexFive 相关的特定样式放在这里 */
/* .IndexFive { ... } */
/* .Click p { ... } */
/* .ClickShow .One { ... } */
/* .DlColumn dl a, .Dl dl a { text-decoration: none; color: inherit; } */ /* 基础的链接样式重置 */

/* 确保图片路径正确，如果图片在 public 文件夹下，路径应以 / 开头 */
/* 如果您的全局样式 (less.less 或 public.css) 已经包含了 IndexFive 的样式，
   并且这些样式是通用的，那么这里可能不需要太多额外的 scoped 样式，
   除非您想覆盖或添加特定于此组件实例的样式。*/

/* 示例：确保链接在 dl 内表现正常 */
.Dl dl, .DlColumn dl {
  cursor: pointer; /* 添加手型光标 */
}

.Dl dl a, .DlColumn dl a {
  display: block; /* 或者 flex 等，根据具体布局需要 */
  text-decoration: none;
  color: inherit; /* 继承父元素颜色，避免 router-link 默认颜色 */
}

.Dl dl a:hover, .DlColumn dl a:hover {
  /* 可选：添加 hover 效果 */
}
</style>